module.exports = __webpack_public_path__ + "static/media/arch1.d7c2b6c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arch1.jpg
// module id = 5788
// module chunks = 0